import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useReactToPrint } from "react-to-print";
import QRCode from "react-qr-code";
import "./sale_invoice.css";

function Invoice_09(props) {
  const { name } = useParams();
  const company = JSON.parse(localStorage.getItem("selected_branch"));

  const data = JSON.parse(localStorage.getItem("data"));

  var quantity = 0;
  const optimize = data.details.map((item, index) => {
    if (name === "delivery_notes") {
      quantity = quantity + item.quantity;
    }
    return item;
  });
  if (name === "delivery_notes") {
    optimize.push({
      sr: "",
      id: "",
      product_name: "",
      product_code: "",
      quantity: `Total : ${quantity}`,
      delivery_note: "",
      product: "",
    });
  }

  const [details, setdetails] = useState(optimize);

  const name_column_formater = (cell, row) => {
    return <div style={{ width: "20vw" }}>{cell}</div>;
  };
  const headerstyle = (column, colIndex) => {
    const englishHeader = column.text.english;
    const arabicHeader = column.text.arabic;

    return (
      <div>
        <div className="light-arabic">{arabicHeader}</div>
        <div>{englishHeader}</div>
      </div>
    );
  };
  const columns = [
    {
      dataField: "sr",
      text: { english: "No", arabic: " رقم" },
      headerFormatter: headerstyle,
      formatter: (cell, row, rowIndex) => rowIndex + 1,
    },
    {
      dataField: "product_name",
      text: {
        english: "Product or Service Description",
        arabic: " وصف للمنتج أو الخدمة",
      },
      headerFormatter: headerstyle,
      formatter: name_column_formater,
    },

    {
      dataField: "quantity",
      text: { english: "QTY", arabic: "الكمية" },
      headerFormatter: headerstyle,
    },
    {
      dataField: "units",
      text: { english: "Units", arabic: "وحدة المنتج" },
      headerFormatter: headerstyle,
      formatter: (cell) => "Ton",
    },
    {
      dataField: "price",
      text: { english: "Unit Price", arabic: " سعر الوحدة" },
      headerFormatter: headerstyle,
    },
    {
      dataField: "vat_amount",
      text: { english: "VAT %", arabic: "   قيمة الضريبة" },
      headerFormatter: headerstyle,
    },
    {
      dataField: "total",
      text: { english: "Gross Total", arabic: `   المبلغ الاجمالي` },
      headerFormatter: headerstyle,
    },
  ];

  const columns_1 = [
    {
      dataField: "sr",
      text: { english: "SR", arabic: "" },
      headerFormatter: headerstyle,
      formatter: (cell, row, rowIndex) => rowIndex + 1,
    },
    {
      dataField: "product_code",
      text: { english: "Item  Code", arabic: "رقم الصنف" },
      headerFormatter: headerstyle,
    },
    {
      dataField: "product_name",
      text: { english: "Description", arabic: "وصف" },
      formatter: name_column_formater,
      headerFormatter: headerstyle,
    },
    {
      dataField: "quantity",
      text: { english: "QTY", arabic: "الكمية" },
      headerFormatter: headerstyle,
    },
  ];

  const componentRef = useRef();
  const handleprint = useReactToPrint({
    content: () => componentRef.current,
    bodyClass: "printclass",
    onAfterPrint: () => {
      window.close();
    },
  });

  useEffect(() => {
    if (data) {
      handleprint();
    }
  }, [data]);

  return (
    <div className=" w-100 " ref={componentRef}>
      {data && (
        <div className="container_1 p-4 robo_font">
          <div className="row ">
            <div className="col-5 text-center">
              <h6 className="m-0">
                <strong>{company.name}</strong>
              </h6>

              <p className="m-0 fw-bold">CR No : {company.cr_number}</p>
              <p className="m-0 fw-bold">VAT No: {company.vat_number}</p>
            </div>
            <div className="col-2 text-center">
              <img
                src={company.logo}
                alt="logo"
                width={"100"}
                height={"80"}
              ></img>
            </div>
            <div className="col-5 text-center arabic_font">
              <h5 className="m-0 fw-bold bold-arabic">
                <strong>{company.arabic_name}</strong>
              </h5>

              <p className="m-0  h6 bold-arabic">
                {" "}
                س.ت : {company.cr_number_arabic}{" "}
              </p>
              <p className="m-0  h6 bold-arabic">
                الرقم ضريبة : {company.vat_number_arabic}
              </p>
            </div>
          </div>
          <hr className="mt-2 mb-2" style={{ border: "1px solid black" }} />
          {/* ##################################################################  */}
          {name === "sales" && (
            <h5 className="text-center fw-bold">
              Tax Invoice - <span className="bold-arabic">فاتورة ضريبية</span>
            </h5>
          )}
          {name === "purchases" && (
            <h5 className="text-center ">Purchase / الشراء</h5>
          )}
          {name === "quotation" && (
            <h5 className="text-center ">Quotation / عرض السعر</h5>
          )}
          {name === "purchase_quotation" && (
            <h5 className="text-center ">
              Purchase Quotation / عرض أسعار الشراء
            </h5>
          )}
          {name === "sale_order" && (
            <h5 className="text-center ">Sale Order / امر البيع</h5>
          )}
          {name === "delivery_notes" && (
            <h4 className="text-center">Delivery Notes - مذكرات التسليم</h4>
          )}

          {/* ##################################################################  */}

          {name === "sales" && (
            <div className="robo_font" style={{ fontSize: "12px" }}>
              <table className="table table-bordered border-dark">
                <thead className="border-bottom-0 ">
                  <tr>
                    <th className="light-arabic">تاريخ الاصدار</th>
                    <th className="light-arabic">رقم الفاتورة</th>
                    <th
                      className="text-center light-arabic"
                      style={{ width: "200px" }}
                    >
                      شروط الدفع
                    </th>
                    <th className="fw-normal" rowSpan={2}>
                      Custmer P.O. NO
                    </th>
                    <th className="fw-normal" rowSpan={2}>
                      Sales Order No
                    </th>
                    <th className="fw-normal" rowSpan={2}>
                      Currency
                    </th>
                  </tr>
                  <tr className="fw-normal">
                    <th className="fw-normal">Issue Date</th>
                    <th className="fw-normal"> Invoice No</th>
                    <th
                      className="text-center fw-normal"
                      style={{ width: "200px" }}
                    >
                      Payment Terms
                    </th>
                  </tr>
                  <tr>
                    <th className="fw-normal">{data.date}</th>
                    <th className="fw-normal"> {data.invoice}</th>
                    <th className="fw-normal text-center">
                      {data?.delivery_details?.payment_terms}
                    </th>
                    <th className="fw-normal">
                      {data?.delivery_details?.PO_number}
                    </th>
                    <th className="fw-normal">
                      {data?.delivery_details?.sale_order_number}{" "}
                    </th>
                    <th className="fw-normal">SAR</th>
                  </tr>
                </thead>
              </table>
            </div>
            // <div
            //   className="d-flex justify-content-between mt-1 p-2 ms-1 me-1"
            //   style={{ border: "1px solid black", borderRadius: "5px" }}
            // >
            //   <div className=" text-left">
            //     <h6 className="m-0">Customer Details : تفاصيل العميل</h6>
            //     <p className="m-0">{data.customer_info.name}</p>
            //     <p className="m-0">VAT No: {data.customer_info.vat_number}</p>
            //     <p className="m-0">Contact: {data.customer_info.contact}</p>
            //     <p className="m-0">Address: {data.customer_info.address}</p>
            //   </div>
            //   <div className=" text-left">
            //     <p className="d-flex justify-content-between m-0">
            //       <span className="me-3">Invoice no:</span>{" "}
            //       <span className="me-3">{data.invoice}</span>{" "}
            //       <span> : رقم الفاتورة</span>
            //     </p>
            //     <p className="d-flex justify-content-between m-0">
            //       <span className="me-3">Invoice Date:</span>{" "}
            //       <span className="me-3">{data.date}</span>{" "}
            //       <span> :تاريخ الفاتورة</span>
            //     </p>
            //     <p className="d-flex justify-content-between m-0">
            //       <span className="me-3">Payment Type:</span>{" "}
            //       <span className="me-3">{data.payment_type} </span>{" "}
            //       <span> :شروط الدفع </span>{" "}
            //     </p>
            //   </div>
            // </div>
          )}

          {name === "purchases" && (
            <div
              className="d-flex justify-content-between mt-1 p-2 ms-1 me-1"
              style={{ border: "1px solid black", borderRadius: "5px" }}
            >
              <div className=" text-left">
                <h6 className="m-0">Supplier Details : تفاصيل العميل</h6>
                <p className="m-0">{data.supplier_name}</p>
              </div>
              <div className=" text-left">
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Invoive no:</span>{" "}
                  <span className="me-3">{data.invoice}</span>{" "}
                  <span> : رقم الفاتورة</span>
                </p>
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Invoive Date:</span>{" "}
                  <span className="me-3">{data.date}</span>{" "}
                  <span> :تاريخ الفاتورة</span>
                </p>
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Payment Type:</span>{" "}
                  <span className="me-3">{data.payment_type} </span>{" "}
                  <span> :شروط الدفع </span>{" "}
                </p>
              </div>
            </div>
          )}

          {name === "quotation" && (
            <div
              className="d-flex justify-content-between mt-1 p-2 ms-1 me-1"
              style={{ border: "1px solid black", borderRadius: "5px" }}
            >
              <div className=" text-left">
                <h6 className="m-0">Customer Details : تفاصيل العميل</h6>
                <p className="m-0">{data.customer_info.name}</p>
                <p className="m-0">VAT No: {data.customer_info.vat_number}</p>
                <p className="m-0">COntact: {data.customer_info.contact}</p>
                <p className="m-0">Address: {data.customer_info.address}</p>
              </div>
              <div className=" text-left">
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Quotation no:</span>{" "}
                  <span className="me-3">{data.quotation_number}</span>{" "}
                  <span> : رقم الفاتورة</span>
                </p>
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Date:</span>{" "}
                  <span className="me-3">{data.date}</span>{" "}
                  <span> :تاريخ </span>
                </p>
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Valid Date:</span>{" "}
                  <span className="me-3">{data.valid_date} </span>{" "}
                  <span> : تاريخ الصلاحية </span>{" "}
                </p>
              </div>
            </div>
          )}

          {name === "purchase_quotation" && (
            <div
              className="d-flex justify-content-between mt-1 p-2 ms-1 me-1"
              style={{ border: "1px solid black", borderRadius: "5px" }}
            >
              <div className=" text-left">
                <h6 className="m-0">Supplier Details : تفاصيل المورد</h6>
                <p className="m-0">{data.supplier_info.name}</p>
                <p className="m-0">VAT No: {data.supplier_info.vat_number}</p>
                <p className="m-0">COntact: {data.supplier_info.contact}</p>
                <p className="m-0">Address: {data.supplier_info.address}</p>
              </div>
              <div className=" text-left">
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Quotation no:</span>{" "}
                  <span className="me-3">{data.quotation_number}</span>{" "}
                  <span> : رقم الفاتورة</span>
                </p>
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Date:</span>{" "}
                  <span className="me-3">{data.date}</span>{" "}
                  <span> :تاريخ </span>
                </p>
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Valid Date:</span>{" "}
                  <span className="me-3">{data.valid_date} </span>{" "}
                  <span> : تاريخ الصلاحية </span>{" "}
                </p>
              </div>
            </div>
          )}

          {name === "sale_order" && (
            <div
              className="d-flex justify-content-between mt-1 p-2 ms-1 me-1"
              style={{ border: "1px solid black", borderRadius: "5px" }}
            >
              <div className=" text-left">
                <h6 className="m-0">Customer Details : تفاصيل العميل</h6>
                <p className="m-0">{data.customer_info.name}</p>
                <p className="m-0">VAT No: {data.customer_info.vat_number}</p>
                <p className="m-0">COntact: {data.customer_info.contact}</p>
                <p className="m-0">Address: {data.customer_info.address}</p>
              </div>
              <div className=" text-left">
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">order no:</span>{" "}
                  <span className="me-3">{data.order_number}</span>{" "}
                  <span> : رقم الأمر</span>
                </p>
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Order Date:</span>{" "}
                  <span className="me-3">{data.date}</span>{" "}
                  <span> : تاريخ الطلب</span>
                </p>
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Delivery Date:</span>{" "}
                  <span className="me-3">{data.delivery_date} </span>{" "}
                  <span> : تاريخ التسليم </span>{" "}
                </p>
                <p className="d-flex justify-content-between m-0">
                  <span className="me-3">Payment Terms:</span>{" "}
                  <span className="me-3">{data.payment_terms} </span>{" "}
                  <span> :شروط الدفع </span>{" "}
                </p>
              </div>
            </div>
          )}

          {/* ################################################################## */}
          {name !== "delivery_notes" && name !== "quotation" && name !== "purchase_quotation" && (
            <div
              className="mt-1 d-flex robo_font"
              style={{ border: "1px solid black" }}
            >
              {name === "sales" ? (
                <div
                  className="col-9 p-2 d-flex justify-content-between"
                  style={{ borderRight: "1px solid black" }}
                >
                  <div>
                    <p className="m-0">Buyer Identification</p>
                    <p className="m-0 fw-bold">{data?.customer_info?.name}</p>
                    <p className="m-0">
                      VAT No: {data?.customer_info?.vat_number}
                    </p>
                    <p className="m-0">
                      Address: {data?.customer_info?.address}
                    </p>
                    <p className=" m-0 mt-4 ">
                      Telephone: {data?.customer_info?.contact}
                    </p>
                  </div>

                  <div className="text-end">
                    <p className="m-0 light-arabic">تحديد هوية العميل</p>
                    <p className="m-0 fw-bold">
                      {data?.customer_info?.arabic_name}
                    </p>
                    <p className="m-0 light-arabic">
                      الرقم الضريبي: {data?.customer_info?.arabic_vat_number}
                    </p>
                    <p className="m-0 light-arabic">
                      ،العنوان: {data?.customer_info?.arabic_address}
                    </p>
                    <p className=" m-0 mt-4 light-arabic">
                      الهاتف: {data?.customer_info?.arabic_contact}
                    </p>
                  </div>
                </div>
              ) : (
                <div
                  className="col-sm-12 p-2 d-flex justify-content-between "
                  style={{ border: "1px solid black", borderRadius: "5px" }}
                >
                  <div>
                    <p className="m-0">Total (Excluding VAT)</p>
                    <p className="m-0">Discount</p>
                    <p className="m-0">
                      Total (Taxable Amount <br />
                      Excluding VAT)
                    </p>
                    <p className="m-0">Total VAT</p>
                    <p className="m-0">Total Amount Due</p>
                  </div>
                  <div>
                    <p className="m-0">
                      اإلجمالي غير شاملة ضريبة القيمة المضافة
                    </p>
                    <p className="m-0"> مجموع الخصومات</p>
                    <p className="m-0">
                      اإلجمالي الخاضع للضريبة شاملة
                      <br /> ضريبة القيمة المضافة
                    </p>
                    <p className="m-0"> مجموع ضريبة القيمة المضاف</p>
                    <p className="m-0"> إجمالي المبلغ المستحق</p>
                  </div>
                  <div className="text-end">
                    <p className="m-0">{data.sub_total}</p>
                    <p className="m-0">{data.discount}</p>
                    <p className="m-0">{data.sub_total}</p>
                    <br />
                    <p className="m-0">{data.vat_amount}</p>
                    <p className="m-0">{data.total}</p>
                  </div>
                </div>
              )}
              {name === "sales" && (
                <div className="text-center col-3 p-2">
                  <QRCode
                    value={data.qr_code}
                    bgColor={"#FFFFFF"}
                    fgColor={"#000000"}
                    size={105}
                  />
                </div>
              )}
            </div>
          )}

          {name !== "delivery_notes" ? (
            <div className=" mt-2 " style={{ minHeight: "3.2in" }}>
              <BootstrapTable
                keyField="id"
                data={details}
                columns={columns}
                bordered={true}
                bootstrap4
                condensed
                classes="invoice_09_table border-secondary"
              />
            </div>
          ) : (
            <div className="m-1 mt-2 " style={{ minHeight: "4.9in" }}>
              <BootstrapTable
                keyField="id"
                data={details}
                columns={columns_1}
                bordered={true}
                bootstrap4
                condensed
                classes="table_class_11"
              />
            </div>
          )}

          <div>
            <table className="table table-bordered border-dark">
              <tbody>
                {/* <tr>
                  <td className="d-flex justify-content-between">
                    <p className="mb-0">Gross Total</p>
                    <p className="mb-0">المجموع الكلي</p>
                  </td>
                  <td className="text-center">{data?.sub_total?.toFixed(2)}</td>
                </tr> */}
                <tr>
                  <td className="d-flex justify-content-between">
                    <p className="mb-0">Amount Before VAT </p>
                    <p className="mb-0 h6 light-arabic">
                      {" "}
                      إجمالي المبلغ (غير شامل ضريبة القيمة المضافة)
                    </p>
                  </td>
                  <td className="text-center">{data?.sub_total?.toFixed(2)}</td>
                </tr>
                <tr>
                  <td className="d-flex justify-content-between">
                    <p className="mb-0">VAT Amount</p>
                    <p className="mb-0 h6 light-arabic"> إجمالي ضريبة القيمة المضافة</p>
                  </td>
                  <td className="text-center">
                    {data?.vat_amount?.toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td className="d-flex justify-content-between">
                    <p className="mb-0"> Amount After VAT</p>
                    <p className="mb-0 h6 light-arabic">
                    إجمالي المبلغ المستحق{" "}
                    </p>
                  </td>
                  <td className="text-center">{data?.total?.toFixed(2)}</td>
                </tr>
                {/* <tr>
                  <td className="d-flex justify-content-between">
                    <p className="mb-0">Less: Advance</p>
                    <p className="mb-0"> أقل: تقدم</p>
                  </td>
                  <td className="text-center">{data?.discount?.toFixed(2)}</td>
                </tr>
                <tr>
                  <td className="d-flex justify-content-between">
                    <p className="mb-0">Net Payable Amount</p>
                    <p className="mb-0"> صافي المبلغ المستحق</p>
                  </td>
                  <td className="text-center">{data?.total?.toFixed(2)}</td>
                </tr> */}
              </tbody>
            </table>
          </div>

          {/* <p className="mb-0 text-center">
            Wadi Al Mathal LTD, 2nd Industrial Area Kharaj Roads, Riyadh KSA
          </p> */}
          <p className="mb-0 text-center light-arabic">
            المملكة العربية السعودية - الرياض حي الملز شارع عبدالرحمن بن الإمام
            - رمز البريدي: ١٢٨٤١
          </p>
          <p className="mb-0 text-center">
            Kingdom of Saudi Arabia - Riyadh - Al-Malaz District - Abdulrahman
            Bin Imam Street - Postal Code: 12841
          </p>
          <p className="mb-0 text-center">
            Telephone: +966 5976 75719 - +966 5803 23493, Email:
            info@wadialmathal.com – Website: www.wadialmathal.com
          </p>
          {/* <div
            className="d-flex justify-content-between"
            style={{ fontSize: "11px" }}
          > */}

          {/* </div> */}
        </div>
      )}
    </div>
  );
}

export default Invoice_09;
